import Modernizr from 'modernizr';
import DetectRTC from 'detectrtc';
import Vue from 'vue';
import App from './App.vue';
import store from './store/';
import VueMoment from 'vue-moment';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faCog, faPause, faPhoneSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

Sentry.init({
	dsn: process.env.VUE_APP_RAVEN_DSN,
	integrations(integrations) {
		if (process.env.NODE_ENV === 'production') integrations.push(new Integrations.Vue({ Vue }));
		return integrations;
	},
});

library.add(faCog, faPause, faPhoneSlash);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(VueMoment);

Vue.config.productionTip = false;

const tests = {
	audio: 'Audio Support',
	eventlistener: 'Event Listener Support',
	fetch: 'Fetch API Support',
	flexbox: 'Flexbox Support',
	getusermedia: 'Microphone Capture Support',
	json: 'JSON Support',
	localstorage: 'LocalStorage Support',
	peerconnection: 'Peer Connection Support',
	promises: '"Promise" Support',
	queryselector: 'QuerySelector Support',
	sessionstorage: 'SessionStorage Support',
	svg: 'SVG Graphics Support',
	detectrtc_webrtc: 'WebRTC Support',
	//detectrtc_speakers: 'Speakers (or headphones) not detected',
	detectrtc_microphone: 'Microphone not detected.',
};

DetectRTC.load(() => {
	Modernizr.addTest({
		detectrtc_webrtc: () => { return DetectRTC.isWebRTCSupported; },
		detectrtc_speakers: () => { return DetectRTC.hasSpeakers; },
		detectrtc_microphone: () => { return DetectRTC.hasMicrophone; },
	});

	window.failedTests = Object.keys(tests).filter((testName) => {
		return ! Modernizr[testName];
	});

	if (window.failedTests.length == 0) {
		Sentry.addBreadcrumb({message: 'Browser Tests passed'});
		window._vm = new Vue({
			render: h => h(App),
			store,
			created() {
				store._root = this;
			}
		}).$mount('#app');
	} else {
		document.getElementById('app').style.display = 'none';
		document.getElementById('deps-fail').style.display = 'block';
		var list = document.getElementById('failedTestsList');

		window.failedTests.forEach(function(test) {
			var li = document.createElement('li');
			li.innerHTML = tests[test];
			list.appendChild(li);
		});
	}
});
